export default __webpack_public_path__ + "static/media/brònach.0b3829fc.mp3";